import * as React from 'react';
import * as ReactDom from 'react-dom';
import { ProvidersProvider } from '../core/context/ProvidersContext';
import { createStandaloneProviders } from '../core/providers/ProviderFactory';
import { StandaloneApp } from './StandaloneApp';
import './global.scss';

const providers = createStandaloneProviders('/api');

const container = document.getElementById('app');
if (!container) throw new Error('Missing #app container in index.html');

ReactDom.render(
  React.createElement(
    ProvidersProvider,
    { providers },
    React.createElement(StandaloneApp)
  ),
  container
);
